
<field [text]='text' class='wrapPhone'
       matTooltipSVG='This checkbox for testing.'>

  <mat-form-field appearance='outline' class='o-matForm {{"o-matForm--"+bcg}}
                {{"o-matForm--"+({value:value,active:active,disabled:disabled,error:error}|getStateInput)}}'>

    <input matInput #inputRef [(ngModel)]='phoneValue' [placeholder]='text|strCase:"capitalize"' [ngClass]='bcg' type='tel' phone
          (ngModelChange)="changeVal.next(forLibrary?.getNumber() || ''); test()"

 [disabled]='disabled'>
  </mat-form-field>

  <error *ngIf='value && !valid' text='Phone is invalid.'></error>


</field>